export const initState = {
  name: {
    data: null,
    error: false,
  },
  surname: {
    data: null,
    error: false,
  },

  investigationGroup: {
    data: [],
    error: false,
  },
  university: {
    data: null,
    error: false,
  },
  investigationLines: {
    data: [],
    error: false,
  },
  profilePicture: {
    data: null,
    error: false,
    notRequired: true,
    extenson: null,
  },
};
